// Shared form helpers: mobile +91 prefix and first-letter capitalization.

export function formatMobilePhone(value: string): string {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.length > 10 && digits.startsWith('91')) {
    digits = digits.slice(2);
  }
  if (digits.length > 10 && digits.startsWith('0')) {
    digits = digits.replace(/^0+/, '');
  }
  digits = digits.slice(0, 10);
  if (!digits) return '';
  return `+91${digits}`;
}

export function getPhoneDigits(value: string): string {
  const raw = String(value || '');
  let digits = raw.replace(/\D/g, '');
  // Strip the country code from stored "+91..." values — never re-append it
  if (raw.trim().startsWith('+91') && digits.length > 2) {
    digits = digits.slice(2);
  } else if (digits.length > 10 && digits.startsWith('91')) {
    digits = digits.slice(2);
  }
  return digits.slice(0, 10);
}

const NON_CAPITALIZE_FIELDS = new Set([
  'email',
  'password',
  'confirmPassword',
  'phone',
  'gender',
  'education',
  'witness1Phone',
  'witness2Phone',
  'currentPinCode',
  'permanentPinCode',
  'aadhaarNumber',
  'witness1Aadhaar',
  'witness2Aadhaar',
  'dateOfBirth',
  'validFrom',
  'validUntil',
  'enrollmentNumber',
]);

export function isPhoneField(name: string): boolean {
  return name === 'phone' || name.endsWith('Phone') || name === 'mobile' || name === 'mobileNumber';
}

export function capitalizeWords(value: string): string {
  // Title case: first letter of each word upper, rest lower
  return String(value || '')
    .toLowerCase()
    .replace(/(^|[\s\-/'(])([a-z])/g, (_m, prefix, letter) => prefix + letter.toUpperCase());
}

export function formatTextField(name: string, value: string): string {
  if (isPhoneField(name)) {
    return formatMobilePhone(value);
  }
  if (NON_CAPITALIZE_FIELDS.has(name)) {
    return value;
  }
  return capitalizeWords(value);
}

export function formatPhoneForDisplay(value: string | undefined | null): string {
  if (!value) return '';
  return formatMobilePhone(value);
}
